import { Injectable, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private readonly _counter = signal(0);

  readonly isLoading = computed(() => this._counter() > 0);

  show(): void {
    this._counter.update((value) => value + 1);
  }

  hide(): void {
    this._counter.update((value) => Math.max(0, value - 1));
  }

  reset(): void {
    this._counter.set(0);
  }
}
